export default {
   init() {

      const programs = document.querySelector('.programs-filter');
      if (!programs) return;

      const filterItems = programs.querySelectorAll('.filter-item');
      const dropdownLists = programs.querySelectorAll('.filter-dropdowns-list');
      const loadMoreWrap = programs.querySelector('.programs-loadmore__wrap');
      const btnLoadMore = loadMoreWrap.querySelector('.programs-loadmore-btn');
      const inProgress = programs.querySelector('.in-progress');
      const results = programs.querySelector('.programs-filter__results');
      const query = results.dataset.query;

      function fetchData(params = {}, append = false) {
         const types = programs.querySelector('#data-type').dataset.value;
         const dates = programs.querySelector('#data-dates').dataset.value;
         const locations = programs.querySelector('#data-locations').dataset.value;
         const paged = results.dataset.currentpage;

         const eventParams = {
            action: "filter_events",
            types: types,
            dates: dates,
            locations: locations,
            query: query,
            paged: paged,
            ...params
         };

         inProgress.classList.add('has-active');

         fetch(block_script.ajax_url, {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: new URLSearchParams({ ...eventParams })
         })
            .then(response => response.json())
            .then(data => handleFetchSuccess(data, append))
            .catch(error => console.error("AJAX Error:", error))
            .finally(() => {
               inProgress.classList.remove('has-active');
            });
      }

      function handleFetchSuccess(data, append) {

         if (append) {
            results.insertAdjacentHTML('beforeend', data.data.items);
         } else {
            results.innerHTML = data.data.items;
         }
         

         // Update load more button
         if (loadMoreWrap) {
            loadMoreWrap.classList.remove('__in-progress');
            loadMoreWrap.style.display = data.data.has_more ? 'block' : 'none';
         }
      }

      // Load more functionality
      function handleLoadMore() {
         const currentpage = results.dataset.currentpage;
         results.dataset.currentpage = parseInt(currentpage) + 1;
         loadMoreWrap.classList.add('__in-progress');
         fetchData({}, true);
      }

      // Filter dropdown toggle
      function toggleFilterDropdown(clickedItem) {
         const key = clickedItem.dataset.filter;
         const targetList = programs.querySelector(`.filter-dropdowns-list.${key}`);

         programs.classList.toggle('active');

         if (clickedItem.classList.contains('has-active')) {
            // Close current dropdown
            clickedItem.classList.remove('has-active');
            if (targetList) targetList.classList.remove('has-active');
         } else {
            // Close all other dropdowns and open current one
            filterItems.forEach(i => i.classList.remove('has-active'));
            dropdownLists.forEach(list => list.classList.remove('has-active'));

            clickedItem.classList.add('has-active');
            if (targetList) targetList.classList.add('has-active');
         }
      }

      // Handle dropdown item selection
      function handleDropdownItemClick(item) {
         const parentUl = item.closest('ul');
         if (!parentUl) return;

         const dropdownValue = parentUl.dataset.dropdowns;
         const targetFilterItem = document.querySelector(`.filter-item.${dropdownValue}`);
         const p = targetFilterItem.querySelector('p');
         const span = p.querySelector('span');

         const clickedValue = item.dataset.value;
         let valueList = p.dataset.value ? p.dataset.value.split(',') : [];

         // Toggle item selection and update value list
         if (item.classList.toggle('has-active')) {
            if (!valueList.includes(clickedValue)) valueList.push(clickedValue);
         } else {
            valueList = valueList.filter(v => v !== clickedValue);
         }

         p.dataset.value = valueList.join(',');

         // Update displayed text
         updateFilterText(parentUl, dropdownValue, span);

         // Close dropdown and reset UI
         closeDropdown(programs, parentUl, targetFilterItem);

         // Fetch new data
         results.dataset.currentpage = 1;
         fetchData();
      }

      function updateFilterText(parentUl, dropdownValue, span) {
         const activeItems = Array.from(parentUl.querySelectorAll('li.has-active'));
         const count = activeItems.length;

         let textResult;
         if (dropdownValue === 'days') {
            const shortList = activeItems.map(i => i.dataset.short);
            textResult = count === 0 ? `All ${dropdownValue}`
               : count > 3 ? shortList.slice(0, 3).join(', ') + ' ...'
                  : shortList.join(', ');
         } else {
            textResult = count === 0 ? `All ${dropdownValue}` : `${count} ${dropdownValue}`;
         }

         if (span) span.textContent = textResult;
      }

      function closeDropdown(programs, dropdownList, filterItem) {
         programs.classList.remove('active');
         dropdownList.classList.remove('has-active');
         filterItem.classList.remove('has-active');
      }

      // Handle filter reset
      function handleFilterReset(restart) {
         const parentUl = restart.closest('ul');
         const dropdownValue = parentUl.dataset.dropdowns;
         const targetFilterItem = document.querySelector(`.filter-item.${dropdownValue}`);

         // Clear all selections
         const allItems = parentUl.querySelectorAll('li');
         allItems.forEach(li => li.classList.remove('has-active'));

         // Reset filter text
         if (targetFilterItem) {
            const span = targetFilterItem.querySelector('p span');
            const p = targetFilterItem.querySelector('p');
            p.dataset.value = "";
            if (span) span.textContent = `All ${dropdownValue}`;
         }

         // Close dropdown and fetch new data
         closeDropdown(programs, parentUl, targetFilterItem);
         results.dataset.currentpage = 1;
         fetchData();
      }

      // Event Listeners
      if (btnLoadMore) {
         btnLoadMore.addEventListener('click', handleLoadMore);
      }

      filterItems.forEach(item => {
         item.addEventListener('click', () => toggleFilterDropdown(item));
      });

      const dropdownItems = programs.querySelectorAll('.filter-dropdowns-list li:not(.restart)');
      dropdownItems.forEach(item => {
         item.addEventListener('click', () => handleDropdownItemClick(item));
      });

      const dropdownRestart = programs.querySelectorAll('.filter-dropdowns-list li.restart');
      dropdownRestart.forEach(restart => {
         restart.addEventListener('click', () => handleFilterReset(restart));
      });

   }
}